import { Controller } from "@hotwired/stimulus";
import { LONG_URL, compose, segmentsOf } from "../sms/segments";

const ATTACHMENTS = "input[id^='direct-upload-value-'], [data-media-id]:not(.no-show)";
const NO_POLL = ["", "none", "0"];

export default class extends Controller {
  static targets = ["message", "summary", "unicode", "urls"];
  static classes = ["over"];
  static values = {
    cap: { type: Number, default: 10 },
    placeholderUrl: String,
    pollPrompt: String,
    labels: Object,
  };

  connect() {
    this.count();
  }

  count() {
    const body = this.messageTarget.value;
    const longUrls = body.match(LONG_URL) || [];
    const mediaCount = this.mediaCount;
    const poll = this.pollIncluded;
    const segments = segmentsOf(
      compose(body, {
        mediaCount,
        pollPrompt: poll ? this.pollPromptValue : "",
        placeholderUrl: this.placeholderUrlValue,
      })
    );
    const over = segments.count > this.capValue;
    const full = segments.count === this.capValue;

    this.summaryTarget.textContent = this.label(over ? "over" : full ? "full" : "summary", {
      count: segments.count,
      cap: this.capValue,
      remaining: segments.remaining,
      links: this.links(mediaCount, poll),
    });
    this.unicodeTarget.textContent = segments.unicodeCharacters.length
      ? this.label("unicode", { characters: segments.unicodeCharacters.join(" ") })
      : "";
    this.urlsTarget.textContent = longUrls.length
      ? this.label("urls", { count: longUrls.length })
      : "";

    this.flag(over);
    this.dispatch("counted", { detail: { over } });
  }

  flag(over) {
    this.messageTarget.setAttribute("aria-invalid", over);
    if (this.hasOverClass) this.element.classList.toggle(this.overClass, over);

    if (!this.form) return;
    this.form.querySelectorAll("[type=submit]").forEach((button) => {
      if (over && !button.disabled) {
        button.disabled = true;
        button.dataset.smsSegmentsDisabled = "";
      } else if (!over && "smsSegmentsDisabled" in button.dataset) {
        button.disabled = false;
        delete button.dataset.smsSegmentsDisabled;
      }
    });
  }

  links(mediaCount, poll) {
    const { attachments, poll: pollLink, attachments_and_poll } = this.labelsValue.links;
    const template = mediaCount
      ? poll
        ? attachments_and_poll
        : attachments
      : poll
        ? pollLink
        : "";
    return this.interpolate(this.pluralize(template, mediaCount), { count: mediaCount });
  }

  label(key, values) {
    return this.interpolate(this.pluralize(this.labelsValue[key], values.count), values);
  }

  pluralize(template, count) {
    return typeof template === "object" ? (count === 1 ? template.one : template.other) : template;
  }

  interpolate(template, values) {
    return template.replace(/%\{(\w+)\}/g, (_, name) => values[name]);
  }

  get mediaCount() {
    return this.form?.querySelectorAll(ATTACHMENTS).length ?? 0;
  }

  get pollIncluded() {
    const poll = this.form?.querySelector("input[name$='[poll_id]']")?.value ?? "";
    const resend = this.form?.querySelector("input[name='poll_instance_id']")?.checked;
    return Boolean(resend) || !NO_POLL.includes(poll);
  }

  get form() {
    return this.element.closest("form");
  }
}
